import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

import PollHeader from "./poll-header";
import RsvpToPerformActionLink from "../../common/components/rsvp-to-perform-action-link";
import RsvpToPerformActionButton from "../../common/components/rsvp-to-perform-action-button";

const PollVote = React.createClass({
  getInitialState: function() {
    return {
        choiceId: null,
        showOtherInput: false,
        otherOption: "",
        validationErrors: {}
      }
    },
  render: function() {
    const poll = this.props.poll;
    const { question, options, id, created, creator, allow_other_options } = poll;
    const hasRsvpd = utils.hasRsvpd();
    const show_other_input = this.state.showOtherInput;
    const other_option = this.state.otherOption;
    const option_nodes = options.map((option, i) => {
      return (
        <fieldset key={`poll-view-${i}`}>
          <label>
            <input
              type="radio"
              name="pollChoice"
              value={option.id}
              onChange={this.handleRadioChange }
              required
              disabled={!hasRsvpd}
            />
            {option.option}
          </label>
        </fieldset>
      )
    });
    return (
      <div>
        { !hasRsvpd &&
          <RsvpToPerformActionLink action="vote" />
        }
        <div className="polls poll-vote simple-shadowbox">
          <form onSubmit={this.handleFormSubmit}>
            <div className="polls-inner">
              <PollHeader poll={poll} />
              {option_nodes}
              { allow_other_options && option_nodes.length < 20 &&
                <fieldset key="poll-view-other">
                  <label>
                    <input
                      type="radio"
                      name="pollChoice"
                      value="other"
                      onChange={this.handleRadioChange}
                      required
                      disabled={!hasRsvpd}
                    />
                    Other
                  </label>
                  { show_other_input &&
                    <span className="input-wrap">
                      <input type="text"
                        className="other-input"
                        value={ other_option }
                        onChange={ this.handleOtherInputChange }
                        maxLength="140"
                        placeholder='If "Other" - type your new poll option here'
                      />
                      { this.state.validationErrors.otherOption &&
                        <span className="validation-error" style={ {display: 'block'} }>
                          { this.state.validationErrors.otherOption }
                        </span>
                      }
                    </span>
                  }
                </fieldset>
              }
              {hasRsvpd &&
                <fieldset>
                  <button className="button-primary small-32">Cast your vote!</button>
                </fieldset>
              }
            </div>
          </form>
          {!hasRsvpd &&
            <div style={{textAlign: 'center'}}>
              <RsvpToPerformActionButton action="vote" />
            </div>
          }
        </div>
      </div>
    )
  },
  handleRadioChange: function(e) {
    if (e.target.value === "other") {
      this.setState({showOtherInput: true});
    } else {
      this.setState({showOtherInput: false});
    }
    this.setState({choiceId: e.target.value});
  },
  handleOtherInputChange: function(e) {
    e.preventDefault();
    this.setState({otherOption: e.target.value});
  },
  handleOptionChange: function(index, e) {
    const newState = update(this.state, {
      options: {
        [index]: {
          option: {$set: e.target.value}
        }
      }
    });
    this.setState(newState);
  },
  handleFormSubmit: function(e) {
    e.preventDefault();
    const pollId = this.props.poll.id;
    const choiceId = this.state.choiceId;
    let otherOption = "";
    if (this.state.choiceId === "other") {
      otherOption = this.state.otherOption;
      if (otherOption.trim() === "") {
        this.setState({
          validationErrors: {
            otherOption: 'The name of your poll choice is required when "Other" is selected.'
          }
        });
        return false;
      }
    }
    if (!choiceId) {
      return false;
    }
    actions.submitResponse(pollId, choiceId, otherOption);
  }
});

export default PollVote;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/polls/components/poll-vote.es6